import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import ModalAddNews from './ModalAddNews';
import NewsList from './NewsList';
import { apiFetch } from '../services/apiService';

import { useAuth } from '../contexts/AuthContext';

const NovinkyComponent = ({ limit }) => {
    const { user } = useAuth();
    const [novinky, setNovinky] = useState([]);

    const fetchAllNews = async () => {
        try {
            let data = await apiFetch('/api/news/getAllNews');

            if (limit) {
                data = data.slice(0, limit);
            }
            setNovinky(data);
        } catch (error) {
            console.error('Chyba při načítání novinek:', error);
        }
    };

    useEffect(() => {
        fetchAllNews();
    }, []);

    return (
        <div>
            <Container fluid className=' text-center p-4'>
                <Row>
                    <Col>
                        <Container>
                            <header className='position-relative'>
                                <h1>Novinky</h1>
                                {user && <ModalAddNews fetchAllNews={fetchAllNews} />}
                            </header>
                            <article><NewsList novinky={novinky} fetchAllNews={fetchAllNews}/></article>
                            {limit && 
                                <Button as={NavLink} to="/novinky" className="mt-3 btn-outline-frodo-dark">
                                    Více novinek
                                </Button>
                            }
                        </Container>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default NovinkyComponent;